import React from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import classnames from "classnames";
import styles from "./styles.module.scss";
import themeStyles from "../../styles/theme.module.scss";
import {useGlobalContext} from "../../contexts/GlobalContext";

const CommonGrid = ({
                      infiniteScrollProps,
                      getTableProps,
                      headerGroups,
                      getTableBodyProps,
                      prepareRow,
                      rows,
                      customHeaderStyles,
                      customBodyStyles,
                      customScrollContainerStyles
                    }) => {
  const {isGlassTheme} = useGlobalContext();
  return (
    <div id="scrollContainer" className={classnames(styles.scrollContainer, customScrollContainerStyles)}>
      <InfiniteScroll {...infiniteScrollProps}>
        <div>
          <table {...getTableProps()} className={classnames('table table-vertical-center', styles.infiniteScrollTable)}>
            <thead className={classnames(
              styles.thead,
              isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
              isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground,
              customHeaderStyles
            )}>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps({
                      style: {
                        width: column.width,
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                      },
                    })}
                  >{column.render('Header')}</th>
                ))}
              </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()} className={classnames(customBodyStyles)}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps({
                      style: {
                        width: cell.column.width,
                        minWidth: cell.column.minWidth,
                        maxWidth: cell.column.maxWidth,
                      },
                    })}>{cell.render('Cell')}</td>;
                  })}
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
    </div>
  )
};

export default CommonGrid;
